import { menuItemsDef, profileNavItemsDef, settingsItemsDef } from "../navigation/navDefinitions";
import { PLATFORM_CONSOLE_SEGMENT } from "../pages/Platform/XprobaseConsole/platformConsoleRoutes";
import { PARTNER_CONSOLE_SEGMENT } from "../pages/Partner/PartnerConsole/partnerConsoleRoutes";

const TENANT_BY_RES = {};
for (const item of [...menuItemsDef, ...profileNavItemsDef, ...settingsItemsDef]) {
  if (item.res) TENANT_BY_RES[item.res] = item.textKey;
  if (item.link) {
    const seg = item.link.replace(/^\//, "").replace(/\//g, ".");
    if (seg) TENANT_BY_RES[seg] = item.textKey;
  }
}

const PLATFORM_SECTION_I18N = {
  [PLATFORM_CONSOLE_SEGMENT.workspaces]: "platformPage.tabWorkspaces",
  [PLATFORM_CONSOLE_SEGMENT.opportunities]: "platformPage.tabOpportunities",
  [PLATFORM_CONSOLE_SEGMENT.insights]: "platformPage.navInsights",
  [PLATFORM_CONSOLE_SEGMENT.productUsage]: "platformPage.tabProductUsage",
  [PLATFORM_CONSOLE_SEGMENT.presence]: "platformPage.navPresence",
  [PLATFORM_CONSOLE_SEGMENT.segments]: "platformPage.tabSegments",
  [PLATFORM_CONSOLE_SEGMENT.governance]: "platformPage.tabGovernance",
  [PLATFORM_CONSOLE_SEGMENT.catalog]: "platformPage.tabCatalogOps",
  [PLATFORM_CONSOLE_SEGMENT.chatbotTemplates]: "platformPage.tabChatbotTemplates",
  [PLATFORM_CONSOLE_SEGMENT.team]: "platformPage.navTeam",
  home: "platformPage.productUsageScreenHome",
};

const PARTNER_SECTION_I18N = {
  [PARTNER_CONSOLE_SEGMENT.overview]: "platformPage.productUsageScreenPartnerOverview",
  [PARTNER_CONSOLE_SEGMENT.workspaces]: "platformPage.tabWorkspaces",
  [PARTNER_CONSOLE_SEGMENT.presence]: "platformPage.navPresence",
  [PARTNER_CONSOLE_SEGMENT.pricing]: "platformPage.productUsageScreenPartnerPricing",
  [PARTNER_CONSOLE_SEGMENT.team]: "platformPage.navTeam",
};

const EXTRA_SCREEN_I18N = {
  home: "platformPage.productUsageScreenHome",
  equipe: "platformPage.productUsageScreenTeam",
  team: "platformPage.productUsageScreenTeam",
  profile: "platformPage.productUsageScreenProfile",
  help: "platformPage.productUsageScreenHelp",
  search: "platformPage.productUsageScreenSearch",
  billing: "nav.billing",
  setup: "platformPage.productUsageScreenSetup",
  "(direto)": "platformPage.productUsageReferrerDirect",
};

function humanizeKey(key) {
  return String(key || "")
    .replace(/^platform\./, "Console: ")
    .replace(/^partner\./, "Parceiro: ")
    .replace(/[._-]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Rótulo amigável para screen_key de analytics.
 * @param {string} screenKey
 * @param {(key: string, opts?: object) => string} t
 */
export function getProductUsageScreenLabel(screenKey, t) {
  const key = String(screenKey || "").trim();
  if (!key) return "—";

  if (key === "(direto)" || key === "null") {
    return t(EXTRA_SCREEN_I18N["(direto)"], { defaultValue: "Acesso direto" });
  }

  const extra = EXTRA_SCREEN_I18N[key];
  if (extra) {
    const tr = t(extra);
    if (tr && tr !== extra) return tr;
  }

  if (key.startsWith("platform.")) {
    const section = key.slice("platform.".length);
    const i18nKey = PLATFORM_SECTION_I18N[section];
    if (i18nKey) {
      const tr = t(i18nKey);
      if (tr && tr !== i18nKey) return tr;
    }
    return t("platformPage.productUsageScreenPlatformPrefix", {
      defaultValue: "Console: {{name}}",
      name: humanizeKey(section),
    });
  }

  if (key.startsWith("partner.")) {
    const section = key.slice("partner.".length);
    const i18nKey = PARTNER_SECTION_I18N[section];
    if (i18nKey) {
      const tr = t(i18nKey);
      if (tr && tr !== i18nKey) return tr;
    }
    return t("platformPage.productUsageScreenPartnerPrefix", {
      defaultValue: "Parceiro: {{name}}",
      name: humanizeKey(section),
    });
  }

  const navKey = TENANT_BY_RES[key];
  if (navKey) {
    const tr = t(navKey);
    if (tr && tr !== navKey) return tr;
  }

  const specific = `platformPage.productUsageScreen_${key.replace(/[^a-zA-Z0-9_]/g, "_")}`;
  const trSpecific = t(specific, { defaultValue: "" });
  if (trSpecific && trSpecific !== specific) return trSpecific;

  return humanizeKey(key);
}

/** Formata YYYY-MM-DD para DD/MM/YYYY. */
export function formatProductUsageDateBR(isoDate) {
  const s = String(isoDate || "").trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return s || "—";
  return `${m[3]}/${m[2]}/${m[1]}`;
}

export function formatProductUsagePeriodBR(from, to) {
  if (!from && !to) return "—";
  if (from && to) return `${formatProductUsageDateBR(from)} — ${formatProductUsageDateBR(to)}`;
  return formatProductUsageDateBR(from || to);
}
